@if (!field.isHidden) {
  <div id="checkbox-div" [formGroup]="group" class="custom-form-field demo-full-width marT24">
    <!-- <label id="checkboxgen-div-label" class="check-label-padding">{{field.displayName}}:</label> -->
    <mat-checkbox
      class="example-margin"
      id="{{ field.name }}"
      [formControlName]="field.name"
      [disabled]="field?.isReadOnly"
      ><span style="font-weight: bold">
        {{ field.displayName }}
      </span></mat-checkbox
    >
  </div>
}
